var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "third_party" }, [
    _c(
      "div",
      [
        _c("div", { staticClass: "money" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "header-left" }, [
              _c(
                "div",
                {
                  staticClass: "bold",
                  on: {
                    click: function($event) {
                      return _vm.buyOrSell(1)
                    }
                  }
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("300417")))]),
                  _vm._v(" "),
                  _c("span", { class: { active: _vm.active == 1 } })
                ]
              ),
              _vm._v(" "),
              _c("span"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bold",
                  on: {
                    click: function($event) {
                      return _vm.buyOrSell(2)
                    }
                  }
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("300367")))]),
                  _vm._v(" "),
                  _c("span", { class: { active: _vm.active == 2 } })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header-right pointer",
                on: { click: _vm.openFAQ }
              },
              [
                _c("i", { staticClass: "iconfont icon-FAQ" }),
                _vm._v(" "),
                _c("span", { staticClass: "bold" }, [_vm._v("FAQ")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "main" }, [
            _c("div", { staticClass: "currency" }, [
              _c("p", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("300366")))
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.zenT() }, [
                _c(
                  "div",
                  { staticClass: "currency-left", class: _vm.demon1() },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("200368")))]),
                    _vm._v(" "),
                    _c("div", { class: { focus: _vm.isfocus } }, [
                      _vm.active == 1
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.amount,
                                expression: "amount"
                              }
                            ],
                            attrs: {
                              type: "text",
                              placeholder:
                                "" +
                                (_vm.channel.minAmount != undefined
                                  ? _vm.channel.minAmount
                                  : ""),
                              maxlength: 12
                            },
                            domProps: { value: _vm.amount },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.amount = $event.target.value
                                },
                                _vm.fiatInput
                              ],
                              blur: function($event) {
                                $event.stopPropagation()
                                _vm.isfocus = false
                              },
                              focus: function($event) {
                                $event.stopPropagation()
                                _vm.isfocus = true
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.active == 2
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.amount,
                                expression: "amount"
                              }
                            ],
                            class: _vm.input1(),
                            attrs: {
                              placeholder:
                                "" +
                                (_vm.channel.minAmount != undefined
                                  ? _vm.channel.minAmount
                                  : ""),
                              type: "text"
                            },
                            domProps: { value: _vm.amount },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.amount = $event.target.value
                                },
                                _vm.currencyInput
                              ],
                              blur: function($event) {
                                $event.stopPropagation()
                                _vm.isfocus = false
                              },
                              focus: function($event) {
                                $event.stopPropagation()
                                _vm.isfocus = true
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.token || _vm.$route.query.token) && _vm.active == 2
                        ? _c(
                            "div",
                            {
                              staticClass: "getMax",
                              on: {
                                click: function($event) {
                                  return _vm.getMax()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("300192")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.isShowPopup(
                                _vm.active == 1 ? "fiat" : "currency"
                              )
                            }
                          }
                        },
                        [
                          _vm.active == 2
                            ? _c("van-image", {
                                attrs: {
                                  "show-loading": false,
                                  src: _vm.currency.img
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "error",
                                      fn: function() {
                                        return [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../assets/images/currency.png")
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  3392930998
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.active == 1
                            ? _c("van-image", {
                                attrs: {
                                  "show-loading": false,
                                  src: _vm.fiat.img
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "error",
                                      fn: function() {
                                        return [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../assets/images/fiat.png")
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1258453611
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.active == 2
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.currency.currency != undefined
                                      ? (
                                          _vm.currency.currency + ""
                                        ).toUpperCase()
                                      : ""
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.active == 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fiat.fiat != undefined
                                      ? _vm.fiat.fiat
                                      : ""
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", { staticClass: "iconfont icon-a-Frame4" })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "errorMessage" }, [
                      _vm._v(_vm._s(_vm.errorMessage))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "currency-right", class: _vm.fixStyle1() },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.active == 1 ? _vm.$t("300369") : _vm.$t("300370")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: _vm.fixStyle2(),
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.isShowPopup(
                              _vm.active == 2 ? "fiat" : "currency"
                            )
                          }
                        }
                      },
                      [
                        _vm.active == 1
                          ? _c("van-image", {
                              attrs: {
                                "show-loading": false,
                                src: _vm.currency.img
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "error",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../assets/images/currency.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3392930998
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.active == 2
                          ? _c("van-image", {
                              attrs: {
                                "show-loading": false,
                                src: _vm.fiat.img
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "error",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../assets/images/fiat.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1258453611
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.active == 1
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.currency.currency != undefined
                                    ? (_vm.currency.currency + "").toUpperCase()
                                    : ""
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.active == 2
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.fiat.fiat != undefined
                                    ? _vm.fiat.fiat
                                    : ""
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "iconfont icon-a-Frame4",
                          class: _vm.fixStyle3()
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.active === 2
                ? _c("p", { staticClass: "userAllAssets" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("300402")) + ": ")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.assetsAmount != ""
                            ? _vm.assetsAmount.substring(
                                0,
                                _vm.assetsAmount.indexOf(".") + 9
                              )
                            : "--"
                        ) +
                          " " +
                          _vm._s(
                            _vm.currency.currency != undefined
                              ? (_vm.currency.currency + "").toUpperCase()
                              : ""
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _vm.token || _vm.$route.query.token
                      ? _c(
                          "span",
                          {
                            staticClass: "tranText",
                            on: { click: _vm.goTransfer }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("9100076")) +
                                "\n            "
                            ),
                            _c(
                              "svg",
                              {
                                staticClass: "icon huazhuanIcon",
                                attrs: { slot: "image", "aria-hidden": "true" },
                                slot: "image"
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-huazhuan-copy" }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payMethods" }, [
              _c("p", { staticClass: "bold" }, [
                _vm._v(
                  _vm._s(_vm.active == 1 ? _vm.$t("300372") : _vm.$t("300373"))
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "payList" }, [
                _vm.payList.length
                  ? _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.isShowPopup("pay")
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("van-image", {
                              attrs: {
                                "show-loading": false,
                                src: _vm.payMethods.img
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "error",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../assets/images/pay.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2482966393
                              )
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.payMethods.name))])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("i", { staticClass: "iconfont icon-a-Frame4" })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.payList.length
                  ? _c("div", { staticClass: "payNoData" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("300108")) +
                          "\n          "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "channel" }, [
              _c("p", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("300374")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "my-circle",
                      rawName: "v-my-circle",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "channelList"
                },
                [
                  _vm._l(_vm.channelList, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "channelItem",
                        class: { channelActive: item.id == _vm.channel.id },
                        on: {
                          click: function($event) {
                            return _vm.chooseData(item, "channel")
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("van-image", {
                              attrs: { "show-loading": false, src: item.img },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "error",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../assets/images/channel.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.name))])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", [_vm._v(_vm._s(item.amount || "--"))]),
                          _vm._v(" \n              "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.active == 2
                                  ? (_vm.fiat.fiat + "").toUpperCase()
                                  : (_vm.currency.currency + "").toUpperCase()
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.channel.id == item.id,
                                expression: "channel.id == item.id"
                              }
                            ],
                            staticClass: "ltr"
                          },
                          [
                            _c("use", {
                              attrs: {
                                "xlink:href": _vm.isDirection
                                  ? "#icon-gouxuan-fan"
                                  : "#icon-gouxuan"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.channelList.length
                    ? _c("div", { staticClass: "channelNoData" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("300108")) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _c("div", { staticClass: "orderMessage" }, [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.$t("300375")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "amount" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("300376")))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(
                      _vm._s(_vm.isPassRules ? _vm.allfee || "0.00" : "0.00") +
                        " " +
                        _vm._s(
                          _vm.active == 1
                            ? (_vm.fiat.fiat + "").toUpperCase()
                            : (_vm.currency.currency + "").toUpperCase()
                        )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("span", [_vm._v(_vm._s(_vm.$t("300377")))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(_vm._s(_vm.$t("300414", { time: "5~60" })))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "disclaimer" }, [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.$t("300378")))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("300380", {
                        name:
                          _vm.channel.name != undefined ? _vm.channel.name : "",
                        server:
                          _vm.channel.protocolLink != undefined
                            ? _vm.channel.protocolLink
                            : "",
                        Customer:
                          _vm.channel.customerLink != undefined
                            ? _vm.channel.customerLink
                            : ""
                      })
                    )
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "howBuyOrSell" }, [
            _c("p", { staticClass: "bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.active == 1 ? _vm.$t("300381") : _vm.$t("300382")
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step" }, [
              _c("div", { staticClass: "stepItem" }, [
                _c("div", [
                  _c("svg", [
                    _c("use", { attrs: { "xlink:href": "#icon-a-xiadan1" } })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stepItem-right" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("300383")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "describe" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("300384")) +
                        "\n            "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stepItem" }, [
                _c("div", [
                  _c("svg", [
                    _c("use", { attrs: { "xlink:href": "#icon-a-KYC1" } })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stepItem-right" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("300385")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "describe" }, [
                    _vm._v("\n              " + _vm._s(_vm.$t("300386")) + "\n")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stepItem" }, [
                _c("div", [
                  _c("svg", [
                    _c("use", { attrs: { "xlink:href": "#icon-dingdan2" } })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stepItem-right" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("\n              " + _vm._s(_vm.$t("300387")) + "\n")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "describe" }, [
                    _vm._v("\n              " + _vm._s(_vm.$t("300388")) + "\n")
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "questions" }, [
            _c("p", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm.$t("300389")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "questionItem" },
              [
                _c(
                  "van-collapse",
                  {
                    model: {
                      value: _vm.activeNames,
                      callback: function($$v) {
                        _vm.activeNames = $$v
                      },
                      expression: "activeNames"
                    }
                  },
                  [
                    _c(
                      "van-collapse-item",
                      {
                        attrs: { name: "1" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(_vm._s(_vm.$t("300390")))
                                    ]),
                                    _vm._v(" "),
                                    _c("van-icon", {
                                      attrs: {
                                        name: _vm.activeNames.includes("1")
                                          ? "minus"
                                          : "plus"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.$t("300391")))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-collapse-item",
                      {
                        attrs: { name: "2" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(_vm._s(_vm.$t("300392")))
                                    ]),
                                    _vm._v(" "),
                                    _c("van-icon", {
                                      attrs: {
                                        name: _vm.activeNames.includes("2")
                                          ? "minus"
                                          : "plus"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c("div", [_vm._v(" " + _vm._s(_vm.$t("300393")))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-collapse-item",
                      {
                        attrs: { name: "3" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(_vm._s(_vm.$t("300394")))
                                    ]),
                                    _vm._v(" "),
                                    _c("van-icon", {
                                      attrs: {
                                        name: _vm.activeNames.includes("3")
                                          ? "minus"
                                          : "plus"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.$t("300395")))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-collapse-item",
                      {
                        attrs: { name: "4" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(_vm._s(_vm.$t("300396")))
                                    ]),
                                    _vm._v(" "),
                                    _c("van-icon", {
                                      attrs: {
                                        name: _vm.activeNames.includes("4")
                                          ? "minus"
                                          : "plus"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.$t("300397")))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-collapse-item",
                      {
                        attrs: { name: "5" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(_vm._s(_vm.$t("300398")))
                                    ]),
                                    _vm._v(" "),
                                    _c("van-icon", {
                                      attrs: {
                                        name: _vm.activeNames.includes("5")
                                          ? "minus"
                                          : "plus"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.$t("300399")))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-collapse-item",
                      {
                        attrs: { name: "6" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(_vm._s(_vm.$t("300400")))
                                    ]),
                                    _vm._v(" "),
                                    _c("van-icon", {
                                      attrs: {
                                        name: _vm.activeNames.includes("6")
                                          ? "minus"
                                          : "plus"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.$t("300401")))])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "consentAgreement" },
          [
            _c(
              "p",
              [
                _c("van-checkbox", {
                  attrs: { "checked-color": "#FFC72B" },
                  model: {
                    value: _vm.checked,
                    callback: function($$v) {
                      _vm.checked = $$v
                    },
                    expression: "checked"
                  }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("300379")))])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-button",
              {
                staticClass: "bold",
                attrs: { disabled: !_vm.isDiable },
                on: { click: _vm.submit }
              },
              [_vm._v(_vm._s(_vm.$t("300056")))]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            style: { height: "60%" },
            attrs: {
              position: "bottom",
              "close-on-click-overlay": false,
              "lock-scroll": true
            },
            model: {
              value: _vm.show,
              callback: function($$v) {
                _vm.show = $$v
              },
              expression: "show"
            }
          },
          [
            _c("div", { staticClass: "popup-container" }, [
              _c("div", { staticClass: "popup-header" }, [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("span", { on: { click: _vm.closePopup } }, [
                  _c("i", { staticClass: "iconfont icon-guanbi1" })
                ])
              ]),
              _vm._v(" "),
              _vm.PopupStatus !== "pay"
                ? _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "van-search",
                        {
                          attrs: {
                            "left-icon": "icon-sousuo",
                            shape: "round",
                            background: "transparent",
                            placeholder:
                              _vm.PopupStatus == "currency"
                                ? _vm.$t("300404")
                                : _vm.$t("300405"),
                            clearable: false
                          },
                          model: {
                            value: _vm.value,
                            callback: function($$v) {
                              _vm.value = $$v
                            },
                            expression: "value"
                          }
                        },
                        [
                          _c("template", { slot: "left-icon" }, [
                            _c("i", { staticClass: "iconfont icon-sousuo" })
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.PopupStatus !== "pay"
                ? _c("p", { staticClass: "popup-name" }, [
                    _vm._v(_vm._s(_vm.name || "--"))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "popup-main-container" },
                [
                  _vm._l(_vm.filterData, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        on: {
                          click: function($event) {
                            return _vm.chooseData(item)
                          }
                        }
                      },
                      [
                        (_vm.PopupStatus == "pay" &&
                          item.name != "Apple Pay" &&
                          _vm.isAndroid) ||
                        _vm.PopupStatus != "pay" ||
                        !_vm.isAndroid
                          ? _c(
                              "div",
                              {
                                class: [
                                  _vm.PopupStatus !== "pay"
                                    ? "noChannel"
                                    : "isChannel",
                                  item.id === _vm.commonObj.id ? "active" : ""
                                ]
                              },
                              [
                                _c("van-image", {
                                  attrs: {
                                    "show-loading": false,
                                    src: item.img
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "error",
                                        fn: function() {
                                          return [
                                            _vm.PopupStatus === "currency"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/currency.png"),
                                                    alt: ""
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.PopupStatus === "fiat"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/fiat.png"),
                                                    alt: ""
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.PopupStatus === "pay"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: require("../../assets/images/pay.png"),
                                                    alt: ""
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _vm.PopupStatus == "pay"
                                  ? _c("span", [_vm._v(_vm._s(item.name))])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.PopupStatus == "currency"
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.currency.toUpperCase())
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.PopupStatus == "fiat"
                                  ? _c("span", [
                                      _vm._v(
                                        " " + _vm._s(item.fiat.toUpperCase())
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.filterData.length
                    ? _c(
                        "div",
                        { staticClass: "PopupNoData" },
                        [
                          _c(
                            "van-empty",
                            {
                              staticClass: "custom-image",
                              attrs: { description: _vm.$t("300108") }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icon",
                                  attrs: {
                                    slot: "image",
                                    "aria-hidden": "true"
                                  },
                                  slot: "image"
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xlink:href":
                                        _vm.$route.query.theme === "sunlight"
                                          ? "#icon-jilu1"
                                          : "#icon-zanwujilu"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "van-dialog",
          {
            attrs: { showConfirmButton: false },
            model: {
              value: _vm.dialogVisible,
              callback: function($$v) {
                _vm.dialogVisible = $$v
              },
              expression: "dialogVisible"
            }
          },
          [
            _vm.user.type != 3 && _vm.$route.query.token
              ? _c(
                  "div",
                  { staticClass: "real-name-verification" },
                  [
                    _c("p", { staticClass: "title bold" }, [
                      _vm._v(_vm._s(_vm.$t("300406")) + " ")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "describe" }, [
                      _vm._v(_vm._s(_vm.$t("300407")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "van-button",
                      {
                        staticClass: "confirm",
                        on: { click: _vm.goVerification }
                      },
                      [_vm._v(_vm._s(_vm.$t("300408")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-button",
                      {
                        staticClass: "cancel",
                        on: {
                          click: function($event) {
                            _vm.dialogVisible = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("300409")))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.user.type == 3 && _vm.$route.query.token
              ? _c(
                  "div",
                  { staticClass: "notSupport" },
                  [
                    _c("p", [_vm._v(_vm._s(_vm.$t("300415")))]),
                    _vm._v(" "),
                    _c(
                      "van-button",
                      { staticClass: "cancel", on: { click: _vm.goBackApp } },
                      [_vm._v(_vm._s(_vm.$t("300286")))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bfc3ea3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bfc3ea3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/thirdParty/index.vue
// module id = OdJl
// module chunks = 0